import { render } from "./GridUtilizatori.vue?vue&type=template&id=f372aa90&scoped=true&ts=true"
import script from "./GridUtilizatori.vue?vue&type=script&lang=ts"
export * from "./GridUtilizatori.vue?vue&type=script&lang=ts"

import "./GridUtilizatori.vue?vue&type=style&index=0&id=f372aa90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f372aa90"]])

export default __exports__